import React, { Component } from "react";

// MetisMenu
import MetisMenu from "metismenujs";
// import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from 'react-i18next';

import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader
} from "../../store/actions";
import withRouter from "../Common/withRouter";
import {
  DATABASE_CLIENT_EDIT,
  DATABASE_CLIENT_FORM,
  DATABASE_CLIENT_PAGE,
  DATABASE_VEHICULE_EDIT,
  DATABASE_VEHICULE_FORM,
  DATABASE_VEHICULE_MANAGER_PAGE,
  DATABASE_VEHICULE_PAGE,
  FERRAILLEURS_ENCHERES_VISIBLES_PAGE,
  FERRAILLEURS_MES_ACHATS_PAGE,
  FERRAILLEURS_TERMS_PAGE,
  MODULE_SELECTOR_PAGE,
  PRAMETRAGE_PAGE,
  RESEAU_PAGE,
  VHU_BID_OFFERS_PAGE,
  VHU_EXPIRED_LOTS_PAGE,
  VHU_LOTS_PAGE,
  VVINAL_PAGE,
  VEHICLE_EXCEL_REPORT_PAGE,
} from "../../routes/routeConstants";

const stripRouteParam = (path) => path.replace("/:id", "");

const moduleMenus = [
  {
    id: "rapports",
    title: "Rapports",
    match: [VEHICLE_EXCEL_REPORT_PAGE],
    items: [
      { label: "États Excel", icon: "ri-file-excel-2-line", path: VEHICLE_EXCEL_REPORT_PAGE, match: [VEHICLE_EXCEL_REPORT_PAGE] },
    ],
  },
  {
    id: "vehicules",
    title: "Véhicules",
    match: [DATABASE_VEHICULE_PAGE, DATABASE_VEHICULE_FORM, DATABASE_VEHICULE_MANAGER_PAGE, stripRouteParam(DATABASE_VEHICULE_EDIT)],
    items: [
      { label: "Véhicules", icon: "ri-car-line", path: DATABASE_VEHICULE_PAGE, match: [DATABASE_VEHICULE_PAGE] },
    ],
  },
  {
    id: "clients",
    title: "Clients",
    match: [DATABASE_CLIENT_PAGE, DATABASE_CLIENT_FORM, stripRouteParam(DATABASE_CLIENT_EDIT)],
    items: [
      { label: "Clients", icon: "ri-user-3-line", path: DATABASE_CLIENT_PAGE, match: [DATABASE_CLIENT_PAGE] },
      { label: "Nouveau client", icon: "ri-user-add-line", path: DATABASE_CLIENT_FORM, match: [DATABASE_CLIENT_FORM, stripRouteParam(DATABASE_CLIENT_EDIT)] },
    ],
  },
  {
    id: "vvinal",
    title: "Valeur vénale",
    match: [VVINAL_PAGE],
    items: [
      { label: "Valeur vénale", icon: "ri-currency-line", path: VVINAL_PAGE, match: [VVINAL_PAGE] },
    ],
  },
  {
    id: "parametrage",
    title: "Parametrage",
    match: [PRAMETRAGE_PAGE],
    items: [
      { label: "Parametrage", icon: "ri-settings-line", path: PRAMETRAGE_PAGE, match: [PRAMETRAGE_PAGE] },
    ],
  },
  {
    id: "encheres",
    title: "Enchères",
    match: [VHU_LOTS_PAGE, VHU_EXPIRED_LOTS_PAGE, VHU_BID_OFFERS_PAGE],
    items: [
      { label: "Lots VHU", icon: "ri-recycle-line", path: VHU_LOTS_PAGE, match: [VHU_LOTS_PAGE] },
      { label: "Enchères expirées", icon: "ri-time-line", path: VHU_EXPIRED_LOTS_PAGE, match: [VHU_EXPIRED_LOTS_PAGE] },
      { label: "Offres VHU", icon: "ri-auction-line", path: VHU_BID_OFFERS_PAGE, match: [VHU_BID_OFFERS_PAGE] },
    ],
  },
  {
    id: "ferrailleurs",
    title: "Ferrailleurs",
    match: [FERRAILLEURS_ENCHERES_VISIBLES_PAGE, FERRAILLEURS_MES_ACHATS_PAGE, FERRAILLEURS_TERMS_PAGE],
    items: [
      { label: "Enchères visibles", icon: "ri-eye-line", path: FERRAILLEURS_ENCHERES_VISIBLES_PAGE, match: [FERRAILLEURS_ENCHERES_VISIBLES_PAGE] },
      { label: "Mes achats", icon: "ri-shopping-bag-3-line", path: FERRAILLEURS_MES_ACHATS_PAGE, match: [FERRAILLEURS_MES_ACHATS_PAGE] },
      { label: "Termes & Conditions", icon: "ri-file-list-3-line", path: FERRAILLEURS_TERMS_PAGE, match: [FERRAILLEURS_TERMS_PAGE] },
    ],
  },
  {
    id: "reseau",
    title: "Réseau",
    match: [RESEAU_PAGE],
    items: [
      { label: "Groupes et ferrailleurs", icon: "ri-team-line", path: RESEAU_PAGE, match: [RESEAU_PAGE] },
    ],
  },
];

const matchesPath = (pathname, paths = []) => paths.some((path) => pathname === path || pathname.startsWith(`${path}/`));
const matchesMenuItem = (pathname, paths = []) => paths.some((path) => pathname === path || (path.endsWith("/edit") && pathname.startsWith(`${path}/`)));
const getCurrentModuleMenu = (pathname) => moduleMenus.find((module) => matchesPath(pathname, module.match)) || moduleMenus[0];

class SidebarContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pathName: this.props.router.location.pathname,
    };

  }

  componentDidMount() {
    this.initMenu();
  }

  UNSAFE_componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {

      if (this.props.type !== prevProps.type) {
        this.initMenu();
      }

    }
    if (this.props.router.location.pathname !== prevProps.router.location.pathname) {
      this.setState({ pathName: this.props.router.location.pathname }, () => {
        this.initMenu();
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  initMenu() {
    if (this.metisMenu) {
      this.metisMenu.dispose();
    }
    this.metisMenu = new MetisMenu("#side-menu");
    const { pathName } = this.state;


    var matchingMenuItem = null;
    var ul = document.getElementById("side-menu");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  activateParentDropdown = item => {
    item.classList.add("active");
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  };

  render() {
    const { pathName } = this.state;
    const currentModule = getCurrentModuleMenu(pathName);

    return (
      <React.Fragment>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{currentModule.title}</li>
            <li>
              <Link
                to={MODULE_SELECTOR_PAGE}
                className="waves-effect"
                title="Retour aux modules"
                aria-label="Retour aux modules"
              >
                <i className="ri-arrow-left-line"></i>
                <span className="ms-1">Retour aux modules</span>
              </Link>
            </li>
            {currentModule.items.map((item) => {
              const isActive = matchesMenuItem(pathName, item.match);
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={isActive ? "active" : ""}
                    title={item.label}
                    aria-label={item.label}
                    aria-current={isActive ? "page" : undefined}
                  >
                    <i className={item.icon}></i>
                    <span className="ms-1">{item.label}</span>
                  </Link>
                </li>
              );
            })}
            
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = state => {
  return { ...state.Layout };
};

export default withRouter(connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeLayoutWidth,
  changePreloader
})(withTranslation()(SidebarContent)));
